import PropTypes from "prop-types";
import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "store/features/auth/authSlice";
import AdminDashboard from "./AdminDashboard";
import DeveloperDashboard from "./DeveloperDashboard";
import QwikMedicDashboard from "./QwikMedicDashboard";
import QwikBistroDashboard from "./QwikBistroDashboard";

const Dashboard = () => {
  const user = useSelector(selectUser);
  const cleanRole = String(user?.role || "").toLowerCase().trim().replace(/[-\s]/g, "_");
  const currentCRM = useSelector(state => state?.user?.currentCRM);

  document.title = "Dashboard | Softzen IT Services";

  return (
    <React.Fragment>
      {cleanRole === "super_admin" || cleanRole === "admin" ? (
        <>
          {(!currentCRM || currentCRM === "qwik_it") && <AdminDashboard />}
          {currentCRM === "qwik_medic" && <QwikMedicDashboard />}
          {currentCRM === "qwik_bistro" && <QwikBistroDashboard />}
        </>
      ) : (
        <DeveloperDashboard />
      )}
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
};

export default Dashboard;
